'use strict';

function NormalEventCount() {
  return events => {
    let count = 0;
    for (let event of events) {
      if (!event.is_error) { count++; }
    }
    return count;
  }
}

export default angular.module('leptonApp.NormalEventCount', [])
  .filter('normalEventCount', [NormalEventCount])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/filter/event-filter/normal-count.filter.js